import type {
    RequestExamplesSearchParams as SharedRequestExamplesSearch,
    RequestExamplesVariant as SharedRequestExamplesVariant,
} from "@albertine/types";
import {
    RequestExamplesSearchParams,
    RequestExamplesVariant as RequestExamplesVariantSchema,
} from "@albertine/types";

export const requestExamplesSearchSchema = RequestExamplesSearchParams;
export const RequestExamplesVariant = RequestExamplesVariantSchema;
export type RequestExamplesSearch = SharedRequestExamplesSearch;
export type RequestExamplesVariant = SharedRequestExamplesVariant;
